<template>
  <div>
    <div class="jc-page-header">
      <h1>
        <a @click="goback">
          <i class="jc-icon-my-angle-left-bold"></i>
        </a>
        {{$t('券额详情')}}
      </h1>
    </div>
    <div class="jc-page-content couponLoading">
      <div class="jc-panel jc-panel-padding">
        <detail-info :quotaNumber="form.quotaNumber"></detail-info>
        <div class="jc-section">
          <div class="jc-section-header">
            <h3 class="jc-section-title">{{$t('券额券记录')}}</h3>
          </div>
          <div class="jc-section-content">
            <div class="jc-container-table">
              <jc-table :data="tableData" style="width: 100%">
                <jc-table-column :label="$t('操作类型')" prop="operationTypeIndex">
                  <template
                    scope="scope"
                  >{{scope.row.operationTypeIndex | filterOperationTypeIndex}}</template>
                </jc-table-column>
                <jc-table-column prop="deliverPin" :label="$t('领取账号')">
                  <template scope="scope">{{scope.row.deliverPin | filterParams}}</template>
                </jc-table-column>
                <jc-table-column prop="deliverFee" :label="$t('转赠金额/发放代金券金额')">
                  <template scope="scope">{{scope.row.deliverFee | formatMoney}}</template>
                </jc-table-column>
                <jc-table-column prop="quotaBalance" :label="$t('券额变动')">
                  <template
                    scope="scope"
                  >{{Number(scope.row.value)>0?'+':''}}{{scope.row.value | formatMoney}}</template>
                </jc-table-column>
                <jc-table-column prop="quotaBalance" :label="$t('券额余额/代金券余额')">
                  <template scope="scope">{{scope.row.quotaBalance | formatMoney}}</template>
                </jc-table-column>
                <jc-table-column prop="quotaNumber" :label="$t('券额码/代金券码')">
                  <template scope="scope">
                    <span
                      v-if="scope.row.operationTypeIndex === 1"
                    >{{scope.row.quotaNumber | filterParams}}</span>
                    <span v-else>{{scope.row.deliverNumber | filterParams}}</span>
                  </template>
                </jc-table-column>
                <jc-table-column :label="$t('操作时间')" prop="updateTime')">
                  <template scope="scope">{{scope.row.updateTime | filterParams}}</template>
                </jc-table-column>
                <jc-table-column :label="$t('状态')" prop="statusIndex')">
                  <template scope="scope">{{scope.row.statusIndex | filterQuotaCouponStatus}}</template>
                </jc-table-column>
                <jc-table-column :label="$t('操作')">
                  <template scope="scope">
                    <jc-button
                      type="text"
                      class="textBreak"
                      @click="showDisableDialog(scope.row)"
                      :disabled="scope.row.canDisable"
                    >{{$t('禁用')}}</jc-button>
                  </template>
                </jc-table-column>
              </jc-table>
              <div class="jc-container-table-actionBar">
                <jc-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="form.currentPage"
                  :page-sizes="[10, 20, 50]"
                  :page-size="form.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                ></jc-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <disable-dialog ref="disableDialog" @submit="disableSubmit"></disable-dialog>
  </div>
</template>

<script>
import getTranslation from '@/i18n/getTranslation'
import {
  queryConsoleQuotaRecordList,
  consoleDisableCoupon,
  consoleDisableQuota
} from '@/api/coupon-api.js'
import DetailInfo from './model/DetailInfo.vue'
import DisableDialog from '@/views/components/DisableDialog.vue'

import quotaPermissionMixin from '@/mixins/quotaPermission-mixin.js'
export default {
  name: 'quotaCouponDetail',
  components: {
    DetailInfo,
    DisableDialog
  },
  mixins: [quotaPermissionMixin],
  data() {
    return {
      detail: {},
      form: {
        quotaNumber: (this.$route.query && this.$route.query.number) || '',
        currentPage: 1,
        pageSize: 10
      },
      deliverNumber: '',
      disableType: 2, // 2:禁用代金券,3:禁用券额券
      tableData: [],
      total: 0
    }
  },
  methods: {
    async query() {
      try {
        let {
          body: {
            result: { data, pageInfo }
          }
        } = await queryConsoleQuotaRecordList(this.form)
        this.tableData = this.handleTableData(data) || []
        this.total = pageInfo.totalRecord
      } catch (e) {
        this.tableData = []
        this.total = 0
      }
    },
    async showDisableDialog(row) {
      this.deliverNumber = row.deliverNumber
      this.disableType = row.operationTypeIndex
      this.$refs.disableDialog.disableShow = true
    },
    /**
     * @event 处理禁用的状态
     */
    handleTableData(data) {
      let typeStatus = [2, 3]
      data &&
        data.map(item => {
          let canDisable = false
          if (
            !typeStatus.includes(item.operationTypeIndex) ||
            item.statusIndex !== 3
          ) {
            canDisable = true
          }
          item.canDisable = canDisable
        })
      return data
    },
    async disableSubmit(reason) {
      try {
        if (this.disableType === 2) {
          await this.disableCoupon(reason)
        } else {
          await this.disableQuota(reason)
        }
      } finally {
        this.$refs.disableDialog.disableShow = false
        this.query()
      }
    },
    // 禁用代金券
    async disableCoupon(reason) {
      let { result } = await consoleDisableCoupon({
        couponNumber: this.deliverNumber,
        disableReason: reason
      })
      if (result && result.data === 1) {
        this.$notify.success(getTranslation('禁用成功'))
      } else {
        this.$notify.error(getTranslation(result.message || '禁用失败'))
      }
    },
    // 禁用券额券
    async disableQuota(reason) {
      let { result } = await consoleDisableQuota({
        quotaNumber: this.deliverNumber,
        disableReason: reason
      })
      if (result && result.data === 1) {
        this.$notify.success(getTranslation('禁用成功'))
      } else {
        this.$notify.error(getTranslation(result.message || '禁用失败'))
      }
    },
    handleCurrentChange(val) {
      this.form.currentPage = val
      this.query()
    },
    handleSizeChange(val) {
      this.form.currentPage = 1
      this.pageSize = val
      this.query()
    },
    goback() {
      this.$router.push({ path: '/cost/quota-coupon' })
    }
  },
  created() {
    this.query()
  }
}
</script>
